module.exports = __webpack_public_path__ + "static/media/image-bot.efb16e52.webp";